import React, { useState } from 'react';
import './AgentIcon.css';

interface AgentIconProps {
  icon: string;
  alt?: string;
  className?: string;
  size?: 'small' | 'medium' | 'large';
}

const AgentIcon = React.memo<AgentIconProps>(({ icon, alt = '', className = '', size = 'medium' }) => {
  const [imageError, setImageError] = useState(false);
  
  // Check if icon is an image path
  const isImagePath = icon.startsWith('/') || icon.startsWith('http') || icon.includes('.');
  
  // Determine size based on prop and context - only used for text icons
  const getTextIconSize = () => {
    switch (size) {
      case 'small': return '12px';
      case 'large': return '20px';
      default: return '14px';
    }
  };

  // Handle image loading errors
  const handleImageError = () => {
    setImageError(true);
  };

  // Generate fallback icon based on agent name
  const getFallbackIcon = () => {
    if (alt.toLowerCase().includes('policytech')) {
      return 'PT';
    }
    if (alt.toLowerCase().includes('policy')) {
      return 'HR';
    }
    // Use first two letters of agent name instead of robot icon
    return alt.slice(0, 2).toUpperCase() || 'AI';
  };
  
  if (isImagePath && !imageError) {
    // All Aldo agent images use contain for consistent display
    return (
      <img 
        src={icon} 
        alt={alt} 
        className={`agent-icon-image ${className}`}
        style={{ 
          width: '100%', 
          height: '100%', 
          objectFit: 'contain',
          objectPosition: 'center',
          borderRadius: 'inherit',
          display: 'block',
          imageRendering: 'auto',
          margin: 'auto'
        }}
        onError={handleImageError}
      />
    );
  }
  
  // Return text icon with appropriate size
  return (
    <span 
      className={className}
      style={{
        fontSize: getTextIconSize(),
        lineHeight: '1'
      }}
    >
      {imageError ? getFallbackIcon() : icon}
    </span>
  );
});

export default AgentIcon; 